// Centralized status values for use across backend and frontend
// Use these constants everywhere instead of hardcoded strings
export var LawsuitStatus;
(function (LawsuitStatus) {
    LawsuitStatus["Draft"] = "draft";
    LawsuitStatus["Analyzing"] = "analyzing";
    LawsuitStatus["QuestionsReady"] = "questions_ready";
    LawsuitStatus["AnalysisComplete"] = "analysis_complete";
    LawsuitStatus["PendingPayment"] = "pending_payment";
    LawsuitStatus["Submitted"] = "submitted";
    LawsuitStatus["InProgress"] = "in_progress";
    LawsuitStatus["Settled"] = "settled";
    LawsuitStatus["Won"] = "won";
    LawsuitStatus["Lost"] = "lost";
    LawsuitStatus["Dismissed"] = "dismissed";
})(LawsuitStatus || (LawsuitStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Succeeded"] = "succeeded";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Canceled"] = "canceled";
})(PaymentStatus || (PaymentStatus = {}));
export var ClassActionStatus;
(function (ClassActionStatus) {
    ClassActionStatus["Active"] = "active";
    ClassActionStatus["Pending"] = "pending";
    ClassActionStatus["Settled"] = "settled";
})(ClassActionStatus || (ClassActionStatus = {}));
export var SubmissionStage;
(function (SubmissionStage) {
    SubmissionStage["Complaint"] = "complaint";
    SubmissionStage["DemandLetter"] = "demand_letter";
    SubmissionStage["Lawsuit"] = "lawsuit";
})(SubmissionStage || (SubmissionStage = {}));
// Helper: Get translation key for a status
export function getLawsuitStatusTranslationKey(status) {
    return `lawsuit.statuses.${status}`;
}
export function getPaymentStatusTranslationKey(status) {
    return `payment.${status}`;
}
export function getClassActionStatusTranslationKey(status) {
    return `classActions.status.${status}`;
}
